import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import { useNavigate } from "react-router-dom";
import { Regex } from "../../utils/regex";
import { login } from "../../Redux/Actions/AuthUser";
import ErrorHandler from "../../lib/errorHandler";
import localStoreUtil from "../../ApiSetUp/localstore.util";
import { LOGIN_TOKEN } from "../../ApiSetUp/AuthApi";
import CommonTextField from "../../Component/Common/CommonTextField";
import CommonAuth from "../../Component/Common/CommonAuth";
import ErrorMessage from "../../Component/Common/ErrorMessage";
import usePageLoader from "../../Redux/hooks/usePageLoader";

const Login = () => {
    // =================== Hooks ===================
    const dispatch = useDispatch();
    const { setSnackBar } = useSnackBar();
    const setFullPageLoader = usePageLoader();
    const navigate = useNavigate();

    // =================== State ===================
    const [errors, setError] = useState({});
    const [data, setData] = useState({
        email: "",
        password: "",
    });

    // =================== Handler ===================
    const handleChangeInput = (e) => {
        const { name, value } = e?.target
        setData({
            ...data,
            [name]: value,
        });
    };

    const forgotPassword = () => {
        navigate('/forgot-password')
    }

    // =================== Validation ===================
    const validateForm = () => {
        let errors = {};
        let formIsValid = true;
        if (!data?.email) {
            formIsValid = false;
            errors["email"] = "* Please Enter Email-Id";
        }
        if (data?.email) {
            if (!data?.email?.match(Regex.emailRegex)) {
                formIsValid = false;
                errors["invalidEmail"] = "* Invalid Email Address";
            }
        }
        if (!data?.password) {
            formIsValid = false;
            errors["password"] = "* Please Enter Password";
        }
        setError(errors);
        return formIsValid;
    };

    // =================== login API ===================
    const _login = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setFullPageLoader(true);
            const body = {
                "email": data?.email,
                "password": data?.password,
            }
            let response = await dispatch(login(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                setTimeout(() => {
                    navigate('/')
                    setFullPageLoader(false);
                }, 1000);
            } else {
                setFullPageLoader(false);
            }
        }
    };


    return (
        <CommonAuth
            onButtonClick={_login}
            btnMarginTop={{ xs: "2rem", sm: "2rem", md: "2.5rem" }}
            children={
                <>
                    <Typography sx={{ fontSize: { xs: "20px", sm: "26px", md: "28px" }, color: "#131313", fontFamily: "Satoshi-Bold !important", mt: { xs: "1rem", sm: "30px", md: "50px" }, }}>
                        Login
                    </Typography>
                    <Grid container spacing={3} mt={{ xs: 0, sm: 1, md: 1 }}>
                        <Grid item xs={12}>
                            <CommonTextField
                                isEmail
                                type={"email"}
                                label={"Email"}
                                color={"#E77843 !important"}
                                placeholder={"Enter Your Email"}
                                value={data.email}
                                onChange={handleChangeInput}
                                name="email"
                            />
                            <ErrorMessage text={data?.email?.length > 0 ? "" : errors["email"]} />
                            <ErrorMessage text={data?.email?.match(Regex.emailRegex) ? "" : errors["invalidEmail"]} />
                        </Grid>
                        <Grid item xs={12}>
                            <CommonTextField
                                isPassword
                                type={"password"}
                                label={"Password"}
                                label2={"Forgot Password?"}
                                color={"#E77843 !important"}
                                placeholder={"Enter Your Password"}
                                value={data.password}
                                onChange={handleChangeInput}
                                onClick={forgotPassword}
                                name="password"
                            />
                            <ErrorMessage text={data?.password?.length > 0 ? "" : errors["password"]} />
                        </Grid>
                    </Grid>
                </>
            }
        />
    );
};

export default Login;
